var video_viewer_default = {
  "video_player": "bVyzw",
  "videoOverlay": "wbY22",
  "video_container": "mp9Zu"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
